import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ManageExternalProductOrderIdService {
  private externalProductionOrderId: string | null = null;

  setExternalProductionOrderId(id: string): void {
    this.externalProductionOrderId = id;
  }

  getExternalProductionOrderId(): string | null {
    return this.externalProductionOrderId;
  }

  clearExternalProductionOrderId(): void {
    this.externalProductionOrderId = null;
  }
}
